"use strict";

var _map = require("babel-runtime/core-js/map");

var _map2 = _interopRequireDefault(_map);

var _iterator = require("babel-runtime/core-js/symbol/iterator");

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = require("babel-runtime/core-js/symbol");

var _symbol2 = _interopRequireDefault(_symbol);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __awaiter = undefined && undefined.__awaiter || function (thisArg, _arguments, P, generator) {
    return new (P || (P = _promise2.default))(function (resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function (resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = undefined && undefined.__generator || function (thisArg, body) {
    var _ = { label: 0, sent: function sent() {
            if (t[0] & 1) throw t[1];return t[1];
        }, trys: [], ops: [] },
        f,
        y,
        t,
        g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof _symbol2.default === "function" && (g[_iterator2.default] = function () {
        return this;
    }), g;
    function verb(n) {
        return function (v) {
            return step([n, v]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) {
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:case 1:
                        t = op;break;
                    case 4:
                        _.label++;return { value: op[1], done: false };
                    case 5:
                        _.label++;y = op[1];op = [0];continue;
                    case 7:
                        op = _.ops.pop();_.trys.pop();continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];t = op;break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];_.ops.push(op);break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [6, e];y = 0;
            } finally {
                f = t = 0;
            }
        }if (op[0] & 5) throw op[1];return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./util");
var Constant_1 = require("./Constant");
var axios_1 = require("axios");
var URL_CNUSER_GLOBALADDR = "/access/AjaxGlobalAddress.do?method=globalCountries";
var URL_CNUSER_LOCALADDR = "/access/AjaxGlobalAddress.do?method=getDivisionByName";
var AddressDataConnectStatic = /** @class */function () {
    function AddressDataConnectStatic() {}
    return AddressDataConnectStatic;
}();
var AddressDataConnectCNUser = /** @class */function () {
    function AddressDataConnectCNUser() {
        this.addressTree = {
            id: Constant_1.ADDRTREE_ROOT_KEY,
            parent: null,
            parentNode: null,
            children: null,
            isLeaf: false,
            ofCountry: "0",
            nameZh: util_1.ADDRTREE_ROOT_NAME,
            namePy: "",
            namePyJoined: "",
            namePyAbbr: "",
            nameEn: util_1.ADDRTREE_ROOT_NAME,
            level: -1,
            levelKey: util_1.ADDRTREE_ROOT_LEVEL_KEY,
            value: Constant_1.ADDRTREE_ROOT_KEY,
            label: util_1.ADDRTREE_ROOT_NAME
        };
        this.allNodesSet = new _map2.default();
        this.globalInited = false;
        this.getRootNode = this.getRootNode.bind(this);
        this.getNodeById = this.getNodeById.bind(this);
        this.getNodeByIdSync = this.getNodeByIdSync.bind(this);
        this.allNodesSet.set("0", this.addressTree);
    }
    // attachNode(node: AddressNodeInternal | AddressNodeLeaf, parent: AddressNode):
    //         AddressNodeInternal | AddressNodeLeaf {
    //     node.parentNode = parent;
    //     node.parent = parent.id;
    //     parent
    //     return node;
    // }
    AddressDataConnectCNUser.prototype.initGlobal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resp, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.globalInited) return [3 /*break*/, 2];
                        return [4 /*yield*/, axios_1.default.get(URL_CNUSER_GLOBALADDR, { withCredentials: true })];
                    case 1:
                        resp = _a.sent();
                        data = resp.data.data.country.map(function (item) {
                            return {
                                id: item.divisionId.toString(),
                                nameZh: item.nameCN,
                                nameEn: item.nameEN,
                                namePy: "",
                                namePyJoined: "",
                                namePyAbbr: "",
                                level: 0,
                                levelKey: util_1.PANE_LEVEL_KEYS[0],
                                ofCountry: "0",
                                value: item.divisionId.toString(),
                                label: item.nameEN.toString(),
                                isLeaf: false,
                                parent: Constant_1.ADDRTREE_ROOT_KEY,
                                parentNode: _this.getRootNode(),
                                children: null
                            };
                        });
                        data.forEach(function (item) {
                            return _this.allNodesSet.set(item.id, item);
                        });
                        data.sort(function (lhs, rhs) {
                            return parseInt(lhs.id.toString()) - parseInt(rhs.id.toString());
                        });
                        this.getRootNode().children = data;
                        this.globalInited = true;
                        _a.label = 2;
                    case 2:
                        return [2 /*return*/, this.getRootNode()];
                }
            });
        });
    };
    AddressDataConnectCNUser.prototype.ensureCountry = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var rootNode, countryNode, resp, data, _mapDivision_, nodes;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.initGlobal()];
                    case 1:
                        rootNode = _a.sent();
                        countryNode = this.allNodesSet.get(id);
                        if (!(countryNode.isLeaf || countryNode.children)) return [3 /*break*/, 2];
                        return [2 /*return*/, countryNode];
                    case 2:
                        return [4 /*yield*/, axios_1.default.get(URL_CNUSER_LOCALADDR, {
                            params: { name: countryNode.nameZh },
                            withCredentials: true
                        })];
                    case 3:
                        resp = _a.sent();
                        data = resp.data.data.globalDivision;
                        _mapDivision_ = function mapDivision_1(item) {
                            // seems we do not need level anymore ...
                            // however, safety is compromised here
                            // since some assumption on level/levelKey is broken here
                            var ret = {
                                id: item.divisionId,
                                isLeaf: item.childDivision.length == 0,
                                parent: item.parentId,
                                parentNode: _this.getNodeByIdSync(item.parentId),
                                ofCountry: id,
                                value: item.divisionId,
                                label: item.divisionName,
                                children: null,
                                level: 65535,
                                levelKey: "NO_LEVEL"
                            };
                            _this.allNodesSet.set(item.divisionId, ret);
                            if (!ret.isLeaf) {
                                ret.children = item.childDivision.map(_mapDivision_);
                                if (id != "1") {
                                    ret.children.sort(function (lhs, rhs) {
                                        return lhs.label.localeCompare(rhs.label);
                                    });
                                }
                            }
                            return ret;
                        };
                        nodes = data.map(_mapDivision_);
                        if (id != "1") {
                            nodes.sort(function (lhs, rhs) {
                                return lhs.label.localeCompare(rhs.label);
                            });
                        }
                        this.allNodesSet.get(id).isLeaf = nodes.length == 0;
                        this.allNodesSet.get(id).children = nodes;
                        return [2 /*return*/, countryNode];
                }
            });
        });
    };
    // interface - IAddressDataConnect
    AddressDataConnectCNUser.prototype.getRootNode = function () {
        return this.addressTree;
    };
    AddressDataConnectCNUser.prototype.getNodeById = function (id, fetchChildren) {
        if (fetchChildren === void 0) {
            fetchChildren = false;
        }
        return __awaiter(this, void 0, void 0, function () {
            var rootNode, country, len;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.initGlobal()];
                    case 1:
                        rootNode = _a.sent();
                        if (!(id == Constant_1.ADDRTREE_ROOT_KEY)) return [3 /*break*/, 2];
                        return [2 /*return*/, rootNode];
                    case 2:
                        country = null;
                        len = id.toString().length;
                        switch (len) {
                            case 6: // province/city/area, Greater China
                            case 9:
                                // town, Greater China
                                country = "1";
                                break;
                            case 18:
                                // all sub-sovereign-state-division except Greater China
                                country = parseInt(id.toString().substr(1, 3)).toString();
                                break;
                            default:
                                if (len <= 3 && fetchChildren) {
                                    country = id.toString();
                                }
                        }
                        if (!country) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.ensureCountry(country)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        return [2 /*return*/, this.allNodesSet.get(id) || null];
                }
            });
        });
    };
    AddressDataConnectCNUser.prototype.getNodeByIdSync = function (id) {
        return this.allNodesSet.get(id) || null;
    };
    return AddressDataConnectCNUser;
}();
var AddressStore = /** @class */function () {
    function AddressStore(impl) {
        this.impl = impl;
    }
    return AddressStore;
}();
exports.AddressStore = AddressStore;
exports.defaultAddressDataConnectStatic = new AddressDataConnectStatic();
// export const defaultAddressStoreStatic = new AddressStore(defaultAddressDataConnectStatic);
exports.defaultAddressDataConnectCNUser = new AddressDataConnectCNUser();
exports.defaultAddressStoreCNUser = new AddressStore(exports.defaultAddressDataConnectCNUser);
//# sourceMappingURL=AddressStore.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/AddressStore.js
// module id = 562
// module chunks = 0